import { useBlocNext } from "@blac/react";
import type { FC } from "react";
import UserPreferencesCubit from "src/state/UserPreferencesCubit/UserPreferencesCubit";

const PersonalizedWelcomeTitle: FC = () => {
  const [, { firstName }] = useBlocNext(UserPreferencesCubit);

  return <>You’re in, {firstName}!</>;
};

export default PersonalizedWelcomeTitle;
